import React from 'react';
import { DataGrid, GridColDef, GridSortModel } from '@mui/x-data-grid';
import { ApiResponse } from '../../../services/api';
import { CargoReportResponse } from '../../../services/cargoService';

interface ReportTableProps {
  rows: any[];
  columns: GridColDef[];
  filters: Record<string, string>;
  apiResponse: ApiResponse<CargoReportResponse> | null;
  paginationModel: any;
  setPaginationModel: any;
  sortModel?: GridSortModel;
  onSortModelChange?: (model: GridSortModel) => void;
}

const ReportTable: React.FC<ReportTableProps> = ({ apiResponse, filters, rows, columns, paginationModel, setPaginationModel, sortModel, onSortModelChange }) => {
  return (
    <div style={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column' }}>
      <div style={{ flex: 1, minHeight: 0 }}>
      <DataGrid
        rows={rows}
        columns={columns}
        rowHeight={36}
        columnHeaderHeight={40}
        pageSizeOptions={[10, 20, 40, 100]}
        pagination
        paginationMode='server'
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        rowCount={apiResponse?.data?.totalItems ?? 0}
        sortingMode='server'
        sortModel={sortModel}
        onSortModelChange={onSortModelChange}
        checkboxSelection={false}
        disableRowSelectionOnClick
        sx={{
          "& .MuiDataGrid-row:nth-of-type(even)": {
            backgroundColor: "#f5f5f5",
          },
          "& .MuiDataGrid-row:nth-of-type(odd)": {
            backgroundColor: "white",
          },
          "& .MuiDataGrid-row:hover": {
            backgroundColor: "#b2d1ff",
        },
        "& .MuiTablePagination-selectLabel": {
          marginTop: "14px",
        },
        "& .MuiTablePagination-displayedRows": {
          marginTop: "14px",
        },
        "& .MuiDataGrid-cell[id='id']": {
          cursor: 'pointer !important',
        },
        "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
          outline: "none",
        },
        "& .MuiDataGrid-row:focus, & .MuiDataGrid-row:focus-within": {
          outline: "none",
        }
        }}
      />
      </div>
    </div>
  );
};

export default ReportTable;